import { InfoCircle } from "@untitledui/icons";
import type { ReactNode } from "react";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";

type GlassMetricTileProps = {
  label: string;
  value: string;
  caption: ReactNode;
  tooltip: string;
};

const glassTileStyle = {
  border: "1px solid rgba(255,255,255,0.20)",
  background: "linear-gradient(180deg, rgba(249,245,240,0.13) 0%, rgba(147,145,142,0.13) 100%)",
  backdropFilter: "blur(2px)",
};

export const GlassMetricTile = ({ label, value, caption, tooltip }: GlassMetricTileProps) => (
  <div className="flex flex-col gap-1.5 w-full rounded-md px-5 py-4" style={glassTileStyle}>
    <div className="flex items-start justify-between w-full">
      <p className="text-sm text-white flex-1">{label}</p>
      <Tooltip title={tooltip}>
        <TooltipTrigger className="inline">
          <InfoCircle className="size-5 text-white/70 shrink-0" />
        </TooltipTrigger>
      </Tooltip>
    </div>
    <div className="flex flex-col w-full">
      <p className="text-[30px] leading-[38px] font-semibold text-white">{value}</p>
      <div className="flex items-center gap-0.5">{caption}</div>
    </div>
  </div>
);
